<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container :disabled="formDisabled">
      <a-form-model ref="form" :model="model" :rules="validatorRules" slot="detail" :colon="false">
        <Detail ref="detailRef" />
        <a-row :gutter="24">
          <a-col :span="24">
            <a-form-model-item :label="$t('审核意见')" prop="audit">
              <a-radio-group v-model="model.audit">
                <a-radio :value="1">{{ $t('通过') }}</a-radio>
                <a-radio :value="0">{{ $t('驳回') }}</a-radio>
              </a-radio-group>
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item :label="$t('备注')" prop="remark">
              <a-textarea v-model="model.remark" :placeholder="$t('请输入备注信息')" :rows="4" />
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row :gutter="24" v-if="model.audit == 1">
         <a-col :span="24">
           <a-form-model-item :label="$t('附件')" prop="acceptanceAnnex">
             <JUpload v-model="fileList" accept=".pdf,.doc,.docx,.xls,.xlsx" @change="uploadChange"/>
           </a-form-model-item>
         </a-col>
         <!-- <a-col :span="24">
           <a-form-model-item label="下一节点操作人" prop="candidateUsers">
             <a-select mode="multiple" placeholder="请选择操作人" v-model="model.candidateUsers">
               <a-select-option :value="item.userName" v-for="item in candidateUsersList">{{item.userRealname}}</a-select-option>
             </a-select> 
           </a-form-model-item>
         </a-col> -->
        </a-row>
      </a-form-model>
    </j-form-container>
  </a-spin>
</template>

<script>
  import { httpAction, getAction, postAction } from '@/api/manage'
  import { validateDuplicateValue,historyFileUrl } from '@/utils/util'
  import JUpload from '@/components/jeecg/JUpload'
  import DetailList from '@/components/tools/DetailList'
  const DetailListItem = DetailList.Item
  import Detail from '../detail'

  export default {
    name: 'ConstructionDetailForm',
    components: {
      JUpload,
      DetailList,
      DetailListItem,
      Detail
    },
    props: {
      //表单禁用
      disabled: {
        type: Boolean,
        default: false,
        required: false
      }
    },
    data () {
      return {
        model:{
         },
        confirmLoading: false,
        url: {
          add: "/jeecg-engineering/engineering/constructionDetail/add",
          edit: "/jeecg-engineering/engineering/constructionDetail/edit",
          queryById: "/jeecg-engineering/engineering/investigationDetail/queryById",
          list:"/jeecg-engineering/engineering/constructionDetail/list",
          upload: "sys/common/upload",
          // userList: "/jeecg-engineering/flowable/definition/userList",
          userList: "/jeecg-engineering/ticket/ticketsUser/list",
          pass: "/jeecg-engineering/flowable/task/completeByDateId",
          reject: "/jeecg-engineering/flowable/task/taskRejectByDataId",
          getApprovalDetail: "/jeecg-engineering/engineering/installationDetail/getApprovalDetail",
          editApproverName: "/jeecg-engineering/ticket/tickets/editApproverName"
        },
        fileList: [],
        fileList1: [],
        fileList2: [],
        fileList3: [],
        candidateUsersList:[],
        bool:false,
        sfInfo: {},
        sgInfo: {},
        defaultkey: ['6','7']
      }
    },
    computed: {
      formDisabled(){
        return this.disabled
      },
      validatorRules() {
        let validateAcceptanceAnnex = (rule, value, callback) => {
          if (value) {
            callback();
          } else {
            callback(new Error(this.$t('请上传附件')));
          }
        };
        return {
          audit:{ required: true,message: this.$t('请选择审批意见'), trigger: 'change' },
          // 审核意见为通过时备注非必填
          remark:{ required: this.model.audit != 1, message: this.$t('请输入备注'), trigger: 'input' },
          acceptanceAnnex:[{ required: true, validator: validateAcceptanceAnnex, trigger: 'change' }],
          candidateUsers:{ required: true,message: this.$t('请选择下一节点操作人'), trigger: 'change' }
        }
      },
    },
    created () {
       //备份model原始值
      this.modelDefault = JSON.parse(JSON.stringify(this.model));
    },
    methods: {
      getUserList(){
        getAction(this.url.userList,{pageSize:999}).then(res=>{
          if(res.success){
            this.candidateUsersList = res.result.records;
          }
        })
      },
      uploadChange(file){
        // this.model.acceptanceAnnex = file;
        this.$set(this.model,'acceptanceAnnex',file);
        this.$nextTick(()=>{
          this.$refs.form.validateField('acceptanceAnnex');
        })
      },
      add () {
        this.edit(this.modelDefault);
      },
      edit (record,bool) {
        let that = this;
        that.bool = bool;
        that.model = Object.assign({}, record);
        if(bool){//工单进来
          this.model.dataId = record.id;
          this.model.installationId = record.ticketsForeignId;
          this.model.ticketsType = record.ticketsType;
          this.model.ticketsId = record.id;
        }else{
          this.model.dataId = record.ticketsId;
          this.model.installationId = record.id;
          this.model.ticketsType = 1;
          this.model.ticketsId = record.ticketsId;
          this.model.id = record.id;
        }
        if (that.model.acceptanceAnnex == null) {
          that.fileList = []
        } else {
          that.fileList = [that.model.acceptanceAnnex];
        }
        this.getUserList();
        this.visible = true;
        this.$nextTick(()=>{
          this.$refs.detailRef.init(record,bool);
        });
      },
      submitForm () {
        const that = this;
        // 触发表单验证
        this.$refs.form.validate(valid => {
          if (valid) {
            that.confirmLoading = true;
            if(that.model.audit == 1){
              postAction(that.url.edit,that.model).then(res=>{
                if(res.success){
                  let params = {
                    // candidateUsers: that.model.candidateUsers,
                    dataId: that.model.dataId,
                    values: {
                      dataId: that.model.dataId,
                    },
                    comment: that.model.remark
                  }
                  postAction(this.url.pass,params).then((res)=>{
                    if(res.success){
                      that.$message.success(that.$t('操作成功'));
                      that.$emit('ok');
                      // // 更新节点处理人
                      // postAction(that.url.editApproverName,{
                      //   id: that.model.id,
                      //   ticketsId: that.model.ticketsId,
                      //   ticketsType: that.model.ticketsType,
                      //   approverName: that.model.candidateUsers&&that.model.candidateUsers.join(','),
                      // }).then(val=>{
                      //   if(res.success){
                      //     // that.$message.success('更新节点处理人成功');
                      //     that.$message.success('操作成功');
                      //     that.$emit('ok');
                      //   }
                      // });
                    }else{
                      that.$message.warning(that.$t("操作失败"));
                    }
                  }).finally(() => {
                    that.confirmLoading = false;
                  })
                }else{
                  that.$message.warning(res.message);
                }
              })
            }else{
              let params = {
                dataId: that.model.dataId,
                values: {
                  dataId: that.model.dataId,
                },
                comment: that.model.remark
              }
              postAction(this.url.reject,params).then((res)=>{
                if(res.success){
                  that.$message.success(that.$t('操作成功'));
                  that.$emit('ok');
                }else{
                  that.$message.warning(that.$t("操作失败"));
                }
              })
            }
          }
        })
      },
    }
  }
</script>
<style lang="less" scoped>
  .avatar-uploader>.ant-upload {
    width: 104px;
    height: 104px;
  }
  .ant-collapse{
    background-color: #fff;
  }
  /deep/.detail-list .content {
    line-height: normal;
  }
</style>